import React from 'react';

const reasons = [
  { icon: '📈', title: 'Beginner to Advanced', desc: 'Structured pathways for every level — no prior experience needed to get started with us.', teal: true },
  { icon: '🖥️', title: 'Live Interactive Classes', desc: 'Real-time sessions with expert trainers. Ask questions and get instant, personalised feedback.', teal: false },
  { icon: '💰', title: 'Affordable Pricing', desc: 'Premium quality at prices that work for students, working professionals and families alike.', teal: false },
  { icon: '🗣️', title: 'Real-life Conversation Training', desc: 'Practice English you actually use — at work, travel, job interviews and everyday situations.', teal: true },
];

export default function WhyRS() {
  return (
    <section id="why" style={{ padding: '5rem 2rem', background: 'var(--bg2)', position: 'relative', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        width: '600px', height: '600px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(15,244,198,0.04) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{ maxWidth: '1120px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '3rem', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#0ff4c6', marginBottom: '10px', fontFamily: "'Syne', sans-serif" }}>Why choose us</div>
            <h2 style={{ fontFamily: "'Syne', sans-serif", fontSize: 'clamp(28px, 4vw, 46px)', fontWeight: '800', letterSpacing: '-1px', color: '#f0f4ff' }}>Why choose <span style={{ color: '#0ff4c6' }}>RS?</span></h2>
          </div>
          <p style={{ fontSize: '15px', color: '#94a3c4', maxWidth: '300px', lineHeight: 1.75, textAlign: 'right', fontWeight: '300' }}>
            Everything you need to go from nervous beginner to confident speaker.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
          {reasons.map((r, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: `1px solid ${r.teal ? 'rgba(15,244,198,0.2)' : 'rgba(99,179,237,0.10)'}`,
              borderRadius: '20px', padding: '1.75rem',
              transition: 'transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
            }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.borderColor = 'rgba(15,244,198,0.4)';
                e.currentTarget.style.boxShadow = '0 0 30px rgba(15,244,198,0.07)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = r.teal ? 'rgba(15,244,198,0.2)' : 'rgba(99,179,237,0.10)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
              <div style={{
                width: '50px', height: '50px',
                background: 'rgba(15,244,198,0.08)', borderRadius: '14px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '22px', marginBottom: '1.25rem',
              }}>{r.icon}</div>
              <h4 style={{ fontFamily: "'Syne', sans-serif", fontSize: '16px', fontWeight: '700', color: '#f0f4ff', marginBottom: '8px', lineHeight: 1.3 }}>{r.title}</h4>
              <p style={{ fontSize: '14px', color: '#94a3c4', lineHeight: '1.7', fontWeight: '300' }}>{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
